export const PORTAL_BRAND_KITS_ENDPOINT = 'branding/v1/brand-kit';
export const BRAND_KIT_COLORS_ENDPOINT = 'branding/v1/colors/brand-kit';